<div>
  <!-- Section of modal used to implement the maintenance message -->
  @if (this.manageService.isSetupMaintenanceMessageActive || this.manageService.isUpdateMaintenanceMessageActive) {
    <section class="setup-maintenance-message-section">
      <article class="message-value">
        {{ this.manageService.messageValue }}
      </article>

      <div class="select-toggle-group">
        <div class="select-stack">
          <select
            class="alert-type"
            [(ngModel)]="this.manageService.alertTypes"
          name="alertType"
          placeholder="Select an alert type">
          <option [ngValue]="null" disabled>Select an alert type</option>
          @for (option of ribbon; track option.value) {
            <option [ngValue]="option.value">
              {{ option.label }}
            </option>
          }
        </select>

          <div class="server-select">
            @if (!allServers) {
              <app-server-select></app-server-select>
            }
          </div>
        </div>
      </div>

      <article class="article-checkbox">
        <div class="filter-toggle">
          <label>Keep message after expiration delay</label>
          <!-- Rounded switch -->
          <label class="switch">
            <input
              type="checkbox"
              [ngModel]="this.manageService.keepAfterDelay"
              name="server"
              (change)="onChangeKeepAfterDelay()"
            />
            <span class="slider round"></span>
          </label>
        </div>

        <div class="toggle-stack">
          <div class="toggle-box">
            <label class="servers-toggle">{{
              "allServers" | translate
            }}</label>
          </div>
          <div class="filter-toggle">
            <!-- Rounded switch -->
            <label class="switch">
              <input
                type="checkbox"
                [ngModel]="allServers"
                name="server"
                (change)="onChangeAllServers()"
              />
              <span class="slider round"></span>
            </label>
          </div>
        </div>
      </article>

      <!-- Section for pickers date/time -->
      <section class="pickers">
        <!-- Article date and time picker for begin date/time -->
        @if (this.manageService.isPicker1Active) {
          <article class="date-time-picker-first">
            <label class="date-time-label">
              Date and time from
            </label>
            <div class="date-picker" [class.readonly-block]="!this.manageService.isDate1ToImplement">
              <!-- date-time-picker.component.html -->
              <mat-form-field appearance="fill">
                <mat-label>Choisir une date</mat-label>
                <input matInput [matDatepicker]="picker" [(ngModel)]="this.manageService.selectedDate1">
                <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="!this.manageService.isDate1ToImplement"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="clock-picker" [class.readonly-block]="!this.manageService.isTime1ToImplement">
              <mat-form-field appearance="fill">
                <mat-label>Heure</mat-label>
                <input matInput placeholder="HH:mm" [(ngModel)]="this.manageService.selectedTime1" type="time" [disabled]="!this.manageService.isTime1ToImplement">
              </mat-form-field>
            </div>
          </article>
        }

        <!-- Article date and time picker for end date/time -->
        @if (this.manageService.isPicker2Active) {
          <article class="date-time-picker">
            <label class="date-time-label">
              Date and time to
            </label>
            <div class="date-picker" [class.readonly-block]="!this.manageService.isDate2ToImplement">
              <!-- date-time-picker.component.html -->
              <mat-form-field appearance="fill">
                <mat-label>Choisir une date</mat-label>
                <input matInput [matDatepicker]="picker" [(ngModel)]="this.manageService.selectedDate2">
                <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="!this.manageService.isDate2ToImplement"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="clock-picker" [class.readonly-block]="!this.manageService.isTime2ToImplement">
              <mat-form-field appearance="fill">
                <mat-label>Heure</mat-label>
                <input matInput placeholder="HH:mm" [(ngModel)]="this.manageService.selectedTime2" type="time" [disabled]="!this.manageService.isTime2ToImplement">
              </mat-form-field>
            </div>
          </article>
        }
      </section>
    </section>
  }


  <!-- Section used for the creation of a new maintenance message -->
  @if (this.manageService.isCreateMaintenanceMessageActive) {
    <section class="create-message-section">
      <label class="create-message-explication">Enter text for the two languages and be sure to put ex: %DATEFROM%, %DATETO%, %TIMEFROM% and %TIMETO% all in uppercase between % symbol if you want to add a date or time for this label</label>
      <textarea class="textarea frech" placeholder="Enter french label" [(ngModel)]="this.manageService.frenchTextarea"></textarea>
      <textarea class="textarea english" placeholder="Enter english label" [(ngModel)]="this.manageService.englishTextarea"></textarea>
      <!-- Eventualy if we support spanish -->
      <!-- <textarea class="textarea spanish" placeholder="Enter spanish label" [(ngModel)]="this.manageService.spanishTextarea"></textarea> -->
      <label class="create-key-explaination">The message key need to be a single word that define the translation as accurately as possible, if you got more then one wolrd put it as this ex: theNewMessageKey</label>
      <input class="input-message-key" placeholder="Enter a message key" [(ngModel)]="this.manageService.messageKey">
    </section>
  }

  <!-- Section for user role selection -->
  @if (this.manageService.isUserRoleActive) {
    <section class="role-set">
      <div class="role-grid">
        @for (item of this.roles; track item.value) {
          <div
            class="role-item"
            (click)="this.manageService.toggleUserRole(item.value)"
            [class.active]="this.manageService.userHasRoles(item.value)"
          >
            {{ item.label }}
          </div>
        }
      </div>
    </section>
  }

  <nav class="nav-btn">
    @if (this.manageService.isUpdateMaintenanceMessageActive) {
      <button class="btn modal-btn" (click)="this.manageService.setInactiveMaintenanceMessage()">Set inactive</button>
    }
    <button class="btn modal-btn" (click)="this.manageService.saveButtonClicked()">Save</button>
    <button class="btn modal-btn" (click)="this.manageService.closeManageModal()">Back</button>
  </nav>
</div>
